var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaseStudiesXP2ImgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 135,
    viewBox: "0 0 104 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip0_2870_5605)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0735 109.635C101.652 109.635 103.69 111.607 103.69 114.132C103.69 116.665 101.652 118.67 99.0496 118.67C96.4486 118.67 94.3672 116.665 94.3672 114.132C94.3672 111.607 96.4486 109.635 99.0496 109.635H99.0735ZM99.0251 110.529C97.0573 110.529 95.5322 112.152 95.5322 114.132C95.5322 116.139 97.0573 117.735 99.0735 117.735C101.037 117.759 102.538 116.139 102.538 114.166C102.538 112.152 101.037 110.529 99.0496 110.529H99.0251ZM98.3339 116.47H97.2804V111.963C97.692 111.912 98.2692 111.829 99.0251 111.829C99.8773 111.829 100.272 111.963 100.574 112.186C100.844 112.38 101.037 112.703 101.037 113.147C101.037 113.691 100.62 114.054 100.094 114.208V114.274C100.54 114.41 100.765 114.767 100.898 115.373C101.037 116.051 101.155 116.301 101.232 116.47H100.122C99.9935 116.301 99.9069 115.924 99.7663 115.373C99.6873 114.905 99.4112 114.684 98.8275 114.684H98.3339V116.47ZM98.3502 113.951H98.854C99.4342 113.951 99.9069 113.742 99.9069 113.28C99.9069 112.866 99.5992 112.601 98.936 112.601C98.6548 112.601 98.4694 112.625 98.3502 112.652V113.951Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2870_5605",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 95,
    height: 112
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833984 0.791016H94.358V111.886H0.833984V0.791016Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2870_5605)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4873 111.886C92.1734 111.886 94.3582 109.712 94.3582 107.038V5.63989C94.3582 2.9677 92.1734 0.791016 89.4873 0.791016H5.7028C3.02133 0.791016 0.833984 2.9677 0.833984 5.63989V107.038C0.833984 109.712 3.02133 111.886 5.7028 111.886H89.4873Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9718 21.8673C86.2808 16.7221 79.7992 14.7972 74.3054 11.5825C71.8766 9.64902 71.7151 6.67144 70.2593 4.41992H67.998C68.484 7.15633 69.1264 9.96958 69.5986 12.705C72.3575 19.2967 80.2903 18.334 84.9798 22.6707L90.9718 27.6632V21.8673Z",
    fill: "#FFCB05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7305 4.41992C55.0636 5.70824 56.3539 6.91312 56.8368 8.20194C60.8809 15.7569 59.0991 25.8834 66.8556 31.6727C74.7808 38.4263 83.0468 43.9006 90.972 50.8119V41.4822C88.3873 37.952 84.492 35.8577 81.1019 33.4389C74.9464 28.7791 65.7268 27.6627 62.8207 19.456C61.1998 14.3113 60.7072 8.44464 56.4996 4.41992H54.7305Z",
    fill: "#FFCB05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6956 53.3784C67.3465 66.4082 82.2377 77.1778 90.9734 91.812V76.5327C81.1053 63.8245 68.4855 54.0226 57.1652 42.4505C47.773 33.6067 58.1316 21.0644 52.6275 10.771C50.8441 8.68532 49.5594 5.8665 46.96 4.41992H41.1523C47.1362 10.2087 54.7318 18.3335 50.8441 27.6627C48.424 32.4782 48.1061 39.0709 49.5594 44.2105C49.5594 44.2105 51.7086 49.1019 55.1495 52.7029C55.4939 53.0553 55.6956 53.3784 55.6956 53.3784Z",
    fill: "#FFCB05"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2808 107.672C70.0877 105.103 68.9619 102.42 68.4841 99.8484C66.3839 92.4502 60.5508 86.8202 55.2082 81.0354L40.0033 64.9537C32.0781 53.5429 40.6512 41.1619 45.6764 31.3544C48.2626 26.5283 49.0649 19.1371 45.6764 14.4698C43.4147 11.4158 39.8413 9.48337 36.6107 7.71776C33.5416 6.59528 30.9482 3.61821 27.2261 4.42062H18.1797C26.4334 8.44433 37.4257 7.71775 43.7325 15.5983C45.9876 18.807 46.6422 23.4804 45.3484 27.1724C41.3048 38.1089 31.1189 46.3101 31.9273 59.3302C32.7286 73.3212 42.9318 83.4411 46.3111 96.3081C47.1348 100.009 48.1052 103.806 48.9039 107.672H69.2808Z",
    fill: "#FFCB05"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3177 106.283C5.63913 107.246 6.53159 107.973 7.66449 108.13H22.385C24.4853 104.585 24.4853 100.008 24.6488 95.9884C23.5169 87.3125 21.5741 79.1043 18.6603 71.3875C14.1323 57.3981 23.6677 45.9853 34.3538 37.6254C39.3505 33.6062 42.931 27.6627 40.8155 21.3814C34.6793 10.1269 20.2782 12.7045 8.80656 11.582L5.08236 11.9001C4.7538 13.0311 4.7538 14.6299 5.08236 15.9182C9.43719 16.7227 13.8088 15.4409 18.6603 15.9182C26.2636 15.7579 34.826 16.4041 38.2385 23.8008C40.004 31.196 31.1207 35.2136 26.7511 39.2318C17.5249 44.5372 9.43719 52.5553 5.3177 62.3835V106.283Z",
    fill: "#FFCB05"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6818 134.75H94.4956V120.716C94.4956 118.45 92.623 116.605 90.3654 116.605H67.2454L64.0586 121.334L88.6248 121.322L88.6818 134.75Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6171 134.749C66.6199 134.749 64.1289 132.298 64.1289 129.319V128.832C64.1289 125.841 66.6199 123.4 69.6171 123.4H89.5702L85.5271 128.123H70.831C70.289 128.123 69.8586 128.557 69.8586 129.1V129.178C69.8586 129.719 70.289 130.163 70.831 130.163H89.5814L86.0416 134.749H69.6171Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0062 128.122C34.9901 128.122 32.5312 125.545 32.5312 122.554V122.08C32.5312 119.089 34.9901 116.637 38.0062 116.637H62.6947L59.5807 121.364H39.2257C38.6832 121.364 38.2508 121.803 38.2508 122.341V122.427C38.2508 122.961 38.6832 123.401 39.2257 123.401H57.0551C60.0677 123.401 62.5322 125.838 62.5322 128.831V129.304C62.5322 132.299 60.0677 134.748 57.0551 134.748H32.6087L35.6915 130.162H55.8382C56.3792 130.162 56.8193 129.72 56.8193 129.179V129.098C56.8193 128.557 56.3792 128.122 55.8382 128.122H38.0062Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53125 127.934L23.6052 127.926C24.6988 127.926 25.2469 128.351 25.2469 129.424L25.2296 134.757H30.3791V126.849C30.3791 124.853 28.7404 123.23 26.7425 123.23L9.08531 123.259L5.53125 127.934Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66488 134.755H0.849609V120.717C0.849609 118.454 2.71247 116.604 5.00068 116.604H31.1653L27.9358 121.2L6.66488 121.197V134.755Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2870_5605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 135,
    fill: "white",
    transform: "translate(0.833984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseStudiesXP2ImgOne);
export default __webpack_public_path__ + "static/media/CaseStudiesX_P2_ImgOne.18cd1cd243219800421b2120573ad2d5.svg";
export { ForwardRef as ReactComponent };